var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgAgriturismiIcon = function SvgAgriturismiIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 214 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.79 106.792h-53.375v53.372h53.375v-53.372Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m131.092 80.096-26.677 26.696h53.375l-26.698-26.696Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M211.165 106.792H157.79v53.372h53.375v-53.372Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m184.468 80.096-26.678 26.696h53.375l-26.697-26.696ZM131.093 80.096h52.879M53.578 1.06c-28.82 0-52.185 23.363-52.185 52.181 0 25.17 17.812 46.173 41.534 51.092v32.527l.04 13.328c.357 5.573 4.959 9.976 10.631 9.976 5.673 0 10.275-4.403 10.632-9.976l.04-9.481v-36.374c23.702-4.92 41.533-25.923 41.533-51.092 0-28.818-23.365-52.182-52.185-52.182h-.04Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.626 120.398c0-11.96 8.906-21.639 19.895-21.639 10.988 0 19.894 9.679 19.894 21.639M104.415 120.398H64.626v39.786h39.789v-39.786Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
};
var Memo = /*#__PURE__*/memo(SvgAgriturismiIcon);
export { Memo as ReactComponent };
export default "/_next/static/svg/a7a166ec16c166c6cc34c07bbd7d94c1.svg";